import TextFieldValidation from '@components/TextFieldValidation/TextFieldValidation';
import UploadButton from '@components/UploadButton/UploadButton';
import { Grid } from '@mui/material';
import React, { FC } from 'react';

interface IdentityProviderSetupProps {
	formik: any;
}

const IdentityProviderSetup: FC<IdentityProviderSetupProps> = ({ formik }) => (
	<Grid container spacing={3}>
		<Grid item xs={12}>
			<TextFieldValidation
				id="idpURL"
				formik={formik}
				fullWidth
				required
				label={intl.tr(
					'pages.authMethods.SSO.identity.provider.input.field.login.title'
				)}
			/>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id="entityID"
				formik={formik}
				fullWidth
				required
				label={intl.tr(
					'pages.authMethods.SSO.identity.provider.input.entityId.title'
				)}
			/>
		</Grid>
		<Grid item xs={12}>
			<TextFieldValidation
				id="idpCert"
				formik={formik}
				fullWidth
				required
				multiline
				rows={6}
				label={intl.tr(
					'pages.authMethods.SSO.identity.provider.input.certificate.title'
				)}
			/>
		</Grid>
		<Grid item xs={12}>
			<UploadButton
				inputName="metadata-sso-download"
				text={intl.tr(
					'pages.authMethods.SSO.identity.provider.input.certificate.upload.link'
				)}
				onFileUpload={(data) => formik.setFieldValue('idpCert', data)}
				readFullFile
			/>
		</Grid>
	</Grid>
);

export default IdentityProviderSetup;
